import { render, staticRenderFns } from "./UniProgramCard.vue?vue&type=template&id=cfbc7de4&scoped=true&"
import script from "./UniProgramCard.vue?vue&type=script&lang=js&"
export * from "./UniProgramCard.vue?vue&type=script&lang=js&"
import style0 from "./UniProgramCard.vue?vue&type=style&index=0&id=cfbc7de4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfbc7de4",
  null
  
)

export default component.exports